import script from "./ExternalOptionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalOptionsList.vue?vue&type=script&setup=true&lang=js"

import "./ExternalOptionsList.vue?vue&type=style&index=0&id=ed682afe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed682afe"]])

export default __exports__